import { ReactiveVar, useReactiveVar } from '@apollo/client'
import { GetContextMenuItemsParams } from 'ag-grid-community'
import { CONTEXT_MENU_OFFSET_PX } from 'components/AgGrid/config/constants'
import AgContextMenu from '../AgContextMenu/AgContextMenu'
import { getRowContextMenuItemsForMUI } from './getRowContextMenuItemsForMUI'

interface AgRowContextMenuContainerProps {
  rowContextMenuVar: ReactiveVar<any>
}

const AgRowContextMenuContainer = ({ rowContextMenuVar }: AgRowContextMenuContainerProps) => {
  const rowContextMenu = useReactiveVar(rowContextMenuVar)

  if (!rowContextMenu) {
    return null
  }

  // Convert CellContextMenuEvent to GetContextMenuItemsParams for menu items
  const menuParams: GetContextMenuItemsParams = {
    ...rowContextMenu.params,
    defaultItems: [],
  }

  const handleClose = () => rowContextMenuVar(false)
  const menuItems = getRowContextMenuItemsForMUI(menuParams, handleClose)

  return (
    <AgContextMenu
      items={menuItems}
      onClose={handleClose}
      anchorPosition={{
        top: rowContextMenu.mouseEvent.clientY + CONTEXT_MENU_OFFSET_PX,
        left: rowContextMenu.mouseEvent.clientX,
      }}
    />
  )
}

export default AgRowContextMenuContainer
